import type { ReactNode } from "react";
import { AtomLabel } from "../atoms/AtomLabel";
import { Text } from "../atoms/Text";
import { cn } from "../lib/cn";

export interface FieldGroupProps {
	id: string;
	label: string;
	helperText?: string;
	errorText?: string;
	required?: boolean;
	children: ReactNode;
	className?: string;
}

function FieldGroup({
	id,
	label,
	helperText,
	errorText,
	required = false,
	children,
	className,
}: FieldGroupProps): ReactNode {
	const hasError = Boolean(errorText);

	return (
		<div className={cn("flex flex-col gap-1.5", className)}>
			<AtomLabel htmlFor={id}>
				{label}
				{required && (
					<span className="ml-0.5 text-destructive" aria-hidden="true">
						*
					</span>
				)}
			</AtomLabel>
			{children}
			{helperText && !hasError && (
				<Text size="xs" textColor="mutedForeground" id={`${id}-helper`}>
					{helperText}
				</Text>
			)}
			{hasError && (
				<Text size="xs" textColor="destructive" id={`${id}-error`} role="alert">
					{errorText}
				</Text>
			)}
		</div>
	);
}
FieldGroup.displayName = "FieldGroup";

export default FieldGroup;
export { FieldGroup };
